module.exports = __webpack_public_path__ + "img/img-logo.69127bf9.png";